export const COMMENT_PREFIXES = {
  ASSIGNEE_CHANGE: 'Assignee Change Reason:',
  DUE_DATE_CHANGE: 'Due Date Change Reason:',
} as const;

export const isAssigneeChangeComment = (comment: string): boolean =>
  comment.startsWith(COMMENT_PREFIXES.ASSIGNEE_CHANGE);

export const filterTaskPerformanceComments = (comment: string): string =>
  isAssigneeChangeComment(comment) ? '' : comment;

export const createAssigneeChangeComment = (reason: string): string =>
  `${COMMENT_PREFIXES.ASSIGNEE_CHANGE} ${reason}`;

export const createDueDateChangeComment = (reason: string): string =>
  `${COMMENT_PREFIXES.DUE_DATE_CHANGE} ${reason}`;
